import { render } from "./ShareFilesModal.vue?vue&type=template&id=c5172ce4&scoped=true"
import script from "./ShareFilesModal.vue?vue&type=script&lang=js"
export * from "./ShareFilesModal.vue?vue&type=script&lang=js"

import "./ShareFilesModal.vue?vue&type=style&index=0&id=c5172ce4&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c5172ce4"]])

export default __exports__